import colors from './colors';

const variants = {
  primary: colors.blue,
  secondary: colors['gray-600'],
  success: colors.green,
  info: colors.cyan,
  warning: colors.yellow,
  danger: colors.red,
  light: colors['gray-100'],
  dark: colors['gray-800'],
};

export default variants;
